import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const CheckCircle = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-4-4.24-4.24 1.41-1.42L11 13.17l5.66-5.66 1.41 1.42L11 16Z"
    />
  </svg>
));
